import { createContext } from 'react';

// Context indicating a DashboardWrapper exists higher in the tree.
const DashboardWrapperContext = createContext(false);

export default DashboardWrapperContext;
